import React, { useState } from 'react';
import Layout from '../components/Layout/Layout';

const FeedbackFormPage = ({ title, type, description }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    feedbackType: type,
    feedback: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simulate form submission
    alert(`Thank you! Your ${type} has been submitted successfully.`);
    setFormData({ ...formData, name: '', email: '', feedback: '' });
  };

  return (
    <Layout>
      <div className="page-container" style={{ maxWidth: '800px', margin: '40px auto', padding: '0 20px' }}>
        <h2 style={{ color: '#0056b3', borderBottom: '2px solid lightblue', paddingBottom: '15px', marginBottom: '20px', textAlign: 'center', fontSize: '2.2rem' }}>
          {title} Form
        </h2>
        
        <p style={{ color: '#555', marginBottom: '30px', fontSize: '1.1rem', lineHeight: '1.6' }}>
          {description}
        </p>

        <div style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', padding: '30px', borderLeft: '4px solid #0056b3', boxShadow: '0 2px 5px rgba(0,0,0,0.05)' }}>
          <h3 style={{ color: '#0056b3', marginBottom: '25px', fontSize: '1.8rem' }}>Submit Your Feedback:</h3>
          
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div>
              <label style={{ display: 'block', fontWeight: 'bold', color: '#0056b3', marginBottom: '8px' }}>Your Name:</label>
              <input 
                type="text" 
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Optional" 
                style={{ width: '100%', padding: '12px', border: '1px solid #ced4da', borderRadius: '4px', fontSize: '1rem', boxSizing: 'border-box' }}
              />
            </div>
            
            <div>
              <label style={{ display: 'block', fontWeight: 'bold', color: '#0056b3', marginBottom: '8px' }}>Your Email:</label>
              <input 
                type="email" 
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Optional (for response)" 
                style={{ width: '100%', padding: '12px', border: '1px solid #ced4da', borderRadius: '4px', fontSize: '1rem', boxSizing: 'border-box' }}
              />
            </div>

            <div>
              <label style={{ display: 'block', fontWeight: 'bold', color: '#0056b3', marginBottom: '8px' }}>Feedback Type:</label>
              <input 
                type="text" 
                name="feedbackType"
                value={formData.feedbackType}
                readOnly
                style={{ width: '100%', padding: '12px', border: '1px solid #ced4da', borderRadius: '4px', fontSize: '1rem', boxSizing: 'border-box', backgroundColor: '#e9ecef', color: '#495057' }}
              />
            </div>

            <div>
              <label style={{ display: 'block', fontWeight: 'bold', color: '#0056b3', marginBottom: '8px' }}>Your Feedback:</label>
              <textarea 
                name="feedback"
                value={formData.feedback}
                onChange={handleChange}
                placeholder="Type your feedback here..." 
                required
                style={{ width: '100%', padding: '12px', border: '1px solid #ced4da', borderRadius: '4px', fontSize: '1rem', minHeight: '200px', boxSizing: 'border-box', resize: 'vertical' }}
              ></textarea>
            </div>

            <div style={{ textAlign: 'center', marginTop: '10px' }}>
              <button 
                type="submit" 
                style={{ backgroundColor: '#007bff', color: '#fff', border: 'none', padding: '12px 30px', fontSize: '1.1rem', borderRadius: '4px', cursor: 'pointer', transition: 'background-color 0.2s' }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
              >
                Send Feedback
              </button>
            </div>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default FeedbackFormPage;
